import styled from 'styled-components';

const IconWrapper = styled.i`
    width: ${props => (props.width || '40px')};
    height:${props => (props.height || '40px')};
    margin-right: ${props => (props.marginRight || '7px')};
    font-size: ${props => (props.fontSize || '14px')};
    color: ${props => (props.iconColor || '#666')};
    vertical-align: ${props => (props.verticalAlign || 'middle')};
    cursor: pointer;
`;

export default IconWrapper;



// WEBPACK FOOTER //
// ./src/components/atoms/IconWrapper.js